import { useSuspenseQuery } from "@apollo/client";
import { GET_DYNAMIC_PROCESS_BY_ID } from "../api/get-dynamic-process-by-id";

export function useDynamicModelToEdit({ modelId }: { modelId?: string }) {
  const { data } = useSuspenseQuery(GET_DYNAMIC_PROCESS_BY_ID, {
    variables: {
      id: modelId as string,
    },
    skip: !modelId,
  });

  return {
    model:
      data?.getDynamicProcessById.__typename === "DynamicModelDefinitionDto"
        ? data.getDynamicProcessById
        : undefined,
  };
}
